import type { BookingsOverviewData, UpcomingBooking as DomainBooking } from '../../domain/types'
import type { BookingsOverviewAPIResponse } from '../types'
import { ACCOUNT_BOOKING_DEFAULT_IMAGE_SRC } from '@/scopes/account/common/constants'
import {
  formatDestination,
  formatPeriod,
} from '@/scopes/account/common/formatters'
import { isActiveBooking } from '@/scopes/account/common/utils/bookingDates'
import {
  getDuration,
  isBookingCancelled,
} from './utils'

export function mapUpcomingBookings(
  apiBookings: BookingsOverviewAPIResponse,
  now: Date = new Date(),
): BookingsOverviewData['upcomingBookings'] {
  const result: Record<string, DomainBooking> = {}

  apiBookings
    .filter(booking =>
      !booking.isOnRequest
      && isActiveBooking(
        booking.departureDate,
        booking.returnDate,
        isBookingCancelled(booking.status),
        now,
      ))
    .forEach((booking) => {
      const collection = booking.destinationInformation?.collection?.trim().toLowerCase()
      const mapped: DomainBooking = {
        bookingNumber: booking.bookingNumber.toString(),
        accommodationName: booking.accommodationName,
        destination: formatDestination(booking.destinationInformation),
        period: formatPeriod(booking.departureDate, booking.returnDate),
        imageSrc: booking.imageSrc || ACCOUNT_BOOKING_DEFAULT_IMAGE_SRC,
        rawDepartureDate: booking.departureDate,
        addedByYou: !!booking.isNonParticipantOfBooking,
        duration: getDuration(booking.departureDate, booking.returnDate),
        hasChanges: booking.bookingChanges?.hasChanges ?? false,
        isGroupBooking: booking.isGroupBooking ?? false,
        isTotallySnow: collection === 'totally_snow',
        isPrimavera: collection === 'primavera',
        showNewBookingDetailPage: !booking.isGroupBooking,
        isMasterBooking: booking.isGroupResponsible ?? false,
      }

      result[mapped.bookingNumber] = mapped
    })

  return result
}
